import { render, staticRenderFns } from "./CompanyRecommendations.vue?vue&type=template&id=5e04302c"
import script from "./CompanyRecommendations.vue?vue&type=script&lang=js"
export * from "./CompanyRecommendations.vue?vue&type=script&lang=js"
import style0 from "./CompanyRecommendations.vue?vue&type=style&index=0&id=5e04302c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports